export const CometChatSettings = {
  chatFeatures: {
    coreMessagingExperience: {
      typingIndicator: false,
      threadConversationAndReplies: true,
      photosSharing: true,
      videoSharing: false,
      audioSharing: false,
      fileSharing: true,
      editMessage: true,
      deleteMessage: true,
      messageDeliveryAndReadReceipts: false,
      userAndFriendsPresence: true,
    },
    deeperUserEngagement: {
      mentions: true,
      reactions: true,
      messageTranslation: true,
      polls: false,
      collaborativeWhiteboard: false,
      collaborativeDocument: true,
      voiceNotes: false,
      emojis: true,
      stickers: true,
      userInfo: true,
      groupInfo: true,
    },
    aiUserCopilot: {
      conversationStarter: false,
      conversationSummary: false,
      smartReply: true,
    },
    groupManagement: {
      createGroup: false,
      addMembersToGroups: true,
      joinLeaveGroup: true,
      deleteGroup: true,
      viewGroupMembers: true,
    },
    moderatorControls: {
      kickUsers: true,
      banUsers: true,
      promoteDemoteMembers: true,
    },
    privateMessagingWithinGroups: {
      sendPrivateMessageToGroupMembers: false,
    },
  },
  callFeatures: {
    voiceAndVideoCalling: {
      oneOnOneVoiceCalling: false,
      oneOnOneVideoCalling: false,
      groupVideoConference: false,
      groupVoiceConference: false,
    },
  },
  layout: {
    withSideBar: true,
    // tabs: ['chats', 'groups'],
    tabs: ['groups'],
    chatType: 'group',
  },
  style: {
    theme: 'light',
    color: {
      brandColor: '#658bff',
      primaryTextLight: '#141414',
      primaryTextDark: '#FFFFFF',
      secondaryTextLight: '#727272',
      secondaryTextDark: '#989898',
    },
    typography: {
      font: 'inter, sans-serif',
      size: 'default',
    },
  },
};
